$(".header__icon--menu").click(function() {
  $(this).parents('sticky-header').toggleClass('menu-drawer-open');
});



$(document).ready(function() {
  $(".product-faq-question").click(function() {
    $(this).parent('.product-faq-question-answer').toggleClass('active');
    $(this).parent('.product-faq-question-answer').find('.product-faq-answer').slideToggle();
  });

  $(".product-faq-question-answer.active .product-faq-answer").show();
});




document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 768 && typeof Swiper !== 'undefined') {
    new Swiper('.as-seen-on-mobile-slider', {
      slidesPerView: 2.2,
      spaceBetween: 15,
      loop: false,
    });
  }
});




document.addEventListener("DOMContentLoaded", function () {
  const videoItems = document.querySelectorAll(".product-meta-video-item");
  const popup = document.querySelector(".kr--video-modal__carousel");
  const closeBtn = popup?.querySelector(".kr_modal_close-button");
  const popupVideos = popup?.querySelectorAll("video");

  // Initialize Swiper
  const videoSwiper = new Swiper(".kr--video-modal__carousel_block", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    navigation: {
      nextEl: ".kr_modal_next--button",
      prevEl: ".kr_modal_prev--button",
    },
    on: {
      slideChange: function () {
        // Pause all videos
        const allVideos = document.querySelectorAll(".kr--video_modal_item video");
        allVideos.forEach(v => {
          v.pause();
          v.currentTime = 0;
        });

        // Delay play to ensure DOM updates
        setTimeout(() => {
          const activeSlide = document.querySelector(".swiper-slide-active video");
          if (activeSlide) {
            activeSlide.muted = false; // 🔊 unmute by default
            activeSlide.play();
            // toggle mute button to active
            const muteControl = activeSlide.closest(".kr--vm_card_item")?.querySelector(".kr--video-carousel__mute-control");
            if (muteControl) muteControl.addClass?.("active");
          }
        }, 150);
      },
    },
  });

  if (!videoItems.length || !popup) return;

  // Thumbnail click → open popup + match video index
  videoItems.forEach((item) => {
    item.addEventListener("click", () => {
      const metaIndex = item.getAttribute("meta__index");

      popup.classList.add("active");
      document.body.classList.add("no-scroll");

      // Pause all videos
      popupVideos.forEach(v => {
        v.pause();
        v.currentTime = 0;
      });

      // Find matching slide by video__index
      const matchingSlide = document.querySelector(
        `.kr--vm_card_item[video__index="${metaIndex}"]`
      );

      if (matchingSlide) {
        const targetSlide = matchingSlide.closest(".swiper-slide");
        const slideIndex = Array.from(targetSlide.parentNode.children).indexOf(targetSlide);

        // Go to correct slide
        videoSwiper.slideTo(slideIndex);

        // Small delay to allow slide transition to complete before play
        setTimeout(() => {
          const video = matchingSlide.querySelector("video");
          if (video) {
            video.muted = false; // 🔊 unmute by default
            video.play();
          }
          // Set mute button active state
          const muteControl = matchingSlide.querySelector(".kr--video-carousel__mute-control");
          if (muteControl) $(muteControl).addClass("active");
        }, 200);
      }
    });
  });

  // Close popup (button)
  closeBtn?.addEventListener("click", () => {
    popup.classList.remove("active");
    document.body.classList.remove("no-scroll");
    popupVideos.forEach(v => v.pause());
  });

  // Close popup (outside click)
  popup.addEventListener("click", (e) => {
    if (e.target.classList.contains("kr--video-modal__carousel")) {
      popup.classList.remove("active");
      document.body.classList.remove("no-scroll");
      popupVideos.forEach(v => v.pause());
    }
  });

  // Mute/unmute toggle
  $(document).on("click", ".kr--video-carousel__mute-control", function () {
    const video = $(this).closest(".kr--vm_card_item").find("video")[0];
    if (video.muted) {
      video.muted = false;
      $(this).addClass("active");
    } else {
      video.muted = true;
      $(this).removeClass("active");
    }
  });
});